// import React, { useEffect, useState } from "react";
// import {
//   collection, addDoc, getDocs, doc,
//   updateDoc, Timestamp, orderBy, query,
// } from "firebase/firestore";
// import { db } from "../firebase";
// import { toast, ToastContainer } from "react-toastify";
// import "../css/datapanel.css";
// import "../css/collection.css";

// const COLLECTION_TYPES = [
//   "Zakat", "Fitrah", "Mustahab Sadqah", "Sehme Imam",
//   "Sehme Saadat", "Fidya", "Kaffara", "Akiqah",
//   "Donation", "Custom",
// ];

// const VOLUNTEERS = [
//   "Ahmad Raza Najmuddin", "Zain", "Abbas Mirza", "Ali Mohammad",
//   "Hussain", "Mahdi", "Arsalan", "Ali Mehdi", "Ali Abbas",
// ];

// // ── Helper: returns customSubType for Custom entries, otherwise type ──────────
// const getEffectiveType = (c) =>
//   c.type === "Custom" && c.customSubType ? c.customSubType : (c.type || "");

// // ── Build a unified timeline from history + deletion event ───────────────────
// // Each event: { at, label, prevAmount, newAmount, recipient, note, eventType }
// const buildTimeline = (entry) => {
//   const events = [];

//   // 1. Creation event
//   events.push({
//     at:        entry.createdAt || entry.date || null,
//     eventType: "created",
//     label:     "Entry Created",
//     newAmount: entry.history && entry.history.length > 0
//       ? entry.history[0].prevAmount
//       : entry.amount,
//     recipient: entry.bookedBy || "—",
//     note:      entry.notes || "",
//   });

//   // 2. Edit / minus-entry events from history[]
//   (entry.history || []).forEach((h) => {
//     events.push({
//       at:        h.at,
//       eventType: h.editNote === "Minus entry deduction" ? "minus" : "edit",
//       label:     h.editNote === "Minus entry deduction" ? "Minus Entry Deduction" : "Manual Edit",
//       prevAmount: h.prevAmount,
//       newAmount:  h.newAmount,
//       recipient:  h.recipient || "—",
//       note:       h.editNote || "",
//     });
//   });

//   // 3. Deletion event (only present when entry is deleted)
//   if (entry.deleted) {
//     events.push({
//       at:        entry.deletedAt || null,
//       eventType: "deleted",
//       label:     "Marked Deleted",
//       prevAmount: entry.amountAtDeletion || entry.amount,
//       newAmount:  "0",
//       recipient:  entry.deletionRecipient || "—",
//       note:       entry.deletionNote || "",
//     });
//   }

//   return events;
// };

// // ── Delete Modal ──────────────────────────────────────────────
// function DeleteModal({ entry, onConfirm, onCancel }) {
//   const [note, setNote] = useState("");
//   const [recipient, setRecipient] = useState("");
//   return (
//     <div className="cl-modal-bg" onClick={onCancel}>
//       <div className="cl-modal" onClick={e => e.stopPropagation()}>
//         <h3 className="cl-modal-title">🗑 Delete Entry</h3>
//         <p className="cl-modal-desc">
//           Deleting <strong>₹{entry.amount} — {getEffectiveType(entry)}</strong>.<br />
//           The entry will be marked as deleted and moved to the deleted view,
//           with full history preserved.
//         </p>
//         <div className="cl-modal-field">
//           <label>Recipient / Who Got Helped *</label>
//           <input
//             value={recipient}
//             onChange={e => setRecipient(e.target.value)}
//             placeholder="e.g. Mohammed Ali, Raza family"
//           />
//         </div>
//         <div className="cl-modal-field">
//           <label>Note (reason for deletion / details)</label>
//           <textarea
//             rows={3}
//             value={note}
//             onChange={e => setNote(e.target.value)}
//             placeholder="e.g. Amount given to beneficiary for medical treatment…"
//           />
//         </div>
//         <div className="cl-modal-actions">
//           <button className="dp-cancel-btn" onClick={onCancel}>Cancel</button>
//           <button
//             className="cl-delete-confirm-btn"
//             onClick={() => {
//               if (!recipient.trim()) { toast.error("Recipient is required."); return; }
//               onConfirm(note, recipient);
//             }}
//           >
//             Confirm Delete
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Edit Modal ────────────────────────────────────────────────
// function EditModal({ entry, onConfirm, onCancel }) {
//   const [amount,    setAmount]    = useState(entry.amount);
//   const [type,      setType]      = useState(entry.type);
//   const [notes,     setNotes]     = useState(entry.notes || "");
//   const [editNote,  setEditNote]  = useState("");
//   const [recipient, setRecipient] = useState("");

//   return (
//     <div className="cl-modal-bg" onClick={onCancel}>
//       <div className="cl-modal" onClick={e => e.stopPropagation()}>
//         <h3 className="cl-modal-title">✏️ Edit Entry</h3>
//         <p className="cl-modal-desc">
//           Original: <strong>₹{entry.amount} — {getEffectiveType(entry)}</strong>
//         </p>
//         <div className="cl-modal-grid">
//           <div className="cl-modal-field">
//             <label>New Amount (₹) *</label>
//             <input
//               type="number"
//               value={amount}
//               onChange={e => setAmount(e.target.value)}
//             />
//           </div>
//           <div className="cl-modal-field">
//             <label>Type</label>
//             <select value={type} onChange={e => setType(e.target.value)}>
//               {COLLECTION_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
//             </select>
//           </div>
//         </div>
//         <div className="cl-modal-field">
//           <label>Entry Notes</label>
//           <input value={notes} onChange={e => setNotes(e.target.value)} placeholder="Notes…" />
//         </div>
//         <div className="cl-modal-field">
//           <label>Who received the difference / reason for edit *</label>
//           <input
//             value={recipient}
//             onChange={e => setRecipient(e.target.value)}
//             placeholder="e.g. Hussain family received ₹500"
//           />
//         </div>
//         <div className="cl-modal-field">
//           <label>Edit Note</label>
//           <textarea
//             rows={2}
//             value={editNote}
//             onChange={e => setEditNote(e.target.value)}
//             placeholder="Describe what changed and why…"
//           />
//         </div>
//         <div className="cl-modal-actions">
//           <button className="dp-cancel-btn" onClick={onCancel}>Cancel</button>
//           <button
//             className="dp-save-btn"
//             onClick={() => {
//               if (!recipient.trim()) { toast.error("Recipient is required."); return; }
//               onConfirm({ amount, type, notes, editNote, recipient });
//             }}
//           >
//             Save Changes
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Minus Entry Modal ─────────────────────────────────────────
// function MinusEntryModal({ collections, onConfirm, onCancel }) {
//   const [amount,     setAmount]     = useState("");
//   const [type,       setType]       = useState("");
//   const [customSub,  setCustomSub]  = useState("");
//   const [removingBy, setRemovingBy] = useState("");
//   const [notes,      setNotes]      = useState("");

//   const availableNonCustomTypes = [...new Set(
//     collections
//       .filter(c => c.type !== "Custom" && !c.deleted && (parseFloat(c.amount) || 0) > 0)
//       .map(c => c.type).filter(Boolean)
//   )];

//   const customSubTypes = [...new Set(
//     collections
//       .filter(c => c.type === "Custom" && c.customSubType && !c.deleted && (parseFloat(c.amount) || 0) > 0)
//       .map(c => c.customSubType)
//   )];

//   const hasCustomEntries = customSubTypes.length > 0;
//   const effectiveLabel = type === "Custom" ? customSub : type;

//   const availableForType = (() => {
//     if (!type) return 0;
//     if (type === "Custom") {
//       if (!customSub) return 0;
//       return collections
//         .filter(c => c.type === "Custom" && c.customSubType === customSub && !c.deleted)
//         .reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
//     }
//     return collections
//       .filter(c => c.type === type && !c.deleted)
//       .reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
//   })();

//   const showBanner = type && (type !== "Custom" || customSub);
//   const parsedAmount = parseFloat(amount);
//   const isOver = showBanner && amount && parsedAmount > availableForType;

//   const handleConfirm = () => {
//     if (!amount || isNaN(parsedAmount) || parsedAmount <= 0) {
//       toast.error("Enter a valid amount greater than 0."); return;
//     }
//     if (!type) { toast.error("Please select a type."); return; }
//     if (type === "Custom" && !customSub) {
//       toast.error("Please select a custom sub-type."); return;
//     }
//     if (availableForType === 0) {
//       toast.error(`No entries found for "${effectiveLabel}".`); return;
//     }
//     if (parsedAmount > availableForType) {
//       toast.error(
//         `Available in "${effectiveLabel}" is ₹${availableForType.toLocaleString("en-IN")}. Please enter ₹${availableForType.toLocaleString("en-IN")} or less.`
//       );
//       return;
//     }
//     const effectiveType = type === "Custom" ? customSub : type;
//     onConfirm({ amount: parsedAmount, effectiveType, removingBy, notes });
//   };

//   return (
//     <div className="cl-modal-bg" onClick={onCancel}>
//       <div className="cl-modal" onClick={e => e.stopPropagation()}>
//         <h3 className="cl-modal-title">➖ Minus Entry</h3>
//         <p className="cl-modal-desc">
//           Deduct an amount from the <strong>oldest entries first</strong> of the selected type.
//           Fully consumed entries stay active with ₹0 and full history preserved.
//         </p>

//         <div className="cl-modal-grid">
//           <div className="cl-modal-field">
//             <label>Type *</label>
//             <select
//               value={type}
//               onChange={e => { setType(e.target.value); setCustomSub(""); }}
//             >
//               <option value="">Select type</option>
//               {availableNonCustomTypes.map(t => <option key={t} value={t}>{t}</option>)}
//               {hasCustomEntries && <option value="Custom">Custom</option>}
//             </select>
//           </div>
//           <div className="cl-modal-field">
//             <label>Amount (₹) *</label>
//             <input
//               type="number"
//               value={amount}
//               onChange={e => setAmount(e.target.value)}
//               placeholder="Enter amount"
//               min="1"
//             />
//           </div>
//         </div>

//         {type === "Custom" && (
//           <div className="cl-modal-field">
//             <label>Custom Sub-Type *</label>
//             <select value={customSub} onChange={e => setCustomSub(e.target.value)}>
//               <option value="">Select custom type</option>
//               {customSubTypes.map(st => <option key={st} value={st}>{st}</option>)}
//             </select>
//           </div>
//         )}

//         {showBanner && (
//           <div className={`cl-minus-available${isOver ? " cl-minus-over" : ""}`}>
//             {isOver
//               ? `⚠️ Exceeds available! Only ₹${availableForType.toLocaleString("en-IN")} available in "${effectiveLabel}"`
//               : `✅ Available in "${effectiveLabel}": ₹${availableForType.toLocaleString("en-IN")}`
//             }
//           </div>
//         )}

//         <div className="cl-modal-field">
//           <label>Removing By</label>
//           <select value={removingBy} onChange={e => setRemovingBy(e.target.value)}>
//             <option value="">Select volunteer</option>
//             {VOLUNTEERS.map(v => <option key={v} value={v}>{v}</option>)}
//           </select>
//         </div>

//         <div className="cl-modal-field">
//           <label>Notes</label>
//           <textarea
//             rows={2}
//             value={notes}
//             onChange={e => setNotes(e.target.value)}
//             placeholder="Reason for deduction, recipient details…"
//           />
//         </div>

//         <div className="cl-modal-actions">
//           <button className="dp-cancel-btn" onClick={onCancel}>Cancel</button>
//           <button className="cl-minus-confirm-btn" onClick={handleConfirm}>
//             Deduct Amount
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Audit Timeline Component ──────────────────────────────────
// function AuditTimeline({ entry }) {
//   const events = buildTimeline(entry);
//   const fmt = ts => {
//     if (!ts) return "—";
//     const d = ts.toDate ? ts.toDate() : new Date(ts);
//     return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
//   };

//   const iconMap = {
//     created: "🟢",
//     edit:    "✏️",
//     minus:   "➖",
//     deleted: "🗑",
//   };

//   return (
//     <div className="cl-timeline">
//       <h4 className="cl-timeline-title">📋 Full Audit Trail</h4>
//       <div className="cl-timeline-list">
//         {events.map((ev, i) => (
//           <div key={i} className={`cl-timeline-item cl-tl-${ev.eventType}`}>
//             <div className="cl-tl-dot">{iconMap[ev.eventType]}</div>
//             <div className="cl-tl-body">
//               <div className="cl-tl-row">
//                 <span className="cl-tl-label">{ev.label}</span>
//                 <span className="cl-tl-date">{fmt(ev.at)}</span>
//               </div>
//               <div className="cl-tl-amounts">
//                 {ev.eventType === "created" ? (
//                   <span className="cl-tl-new">₹{parseFloat(ev.newAmount || 0).toLocaleString("en-IN")}</span>
//                 ) : (
//                   <>
//                     <span className="cl-tl-prev">₹{parseFloat(ev.prevAmount || 0).toLocaleString("en-IN")}</span>
//                     <span className="cl-tl-arrow">→</span>
//                     <span className={`cl-tl-new ${ev.eventType === "deleted" ? "cl-tl-zero" : ""}`}>
//                       ₹{parseFloat(ev.newAmount || 0).toLocaleString("en-IN")}
//                     </span>
//                   </>
//                 )}
//               </div>
//               {ev.recipient && ev.recipient !== "—" && (
//                 <div className="cl-tl-meta">👤 {ev.recipient}</div>
//               )}
//               {ev.note && (
//                 <div className="cl-tl-note">{ev.note}</div>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// // ── Main Component ────────────────────────────────────────────
// const Collection = () => {
//   const [collections,    setCollections]    = useState([]);
//   const [loading,        setLoading]        = useState(true);
//   const [showForm,       setShowForm]       = useState(false);
//   const [showDeleted,    setShowDeleted]    = useState(false);
//   const [search,         setSearch]         = useState("");
//   const [typeFilter,     setTypeFilter]     = useState("all");
//   const [sortOrder,      setSortOrder]      = useState("desc");
//   const [expanded,       setExpanded]       = useState(null);
//   const [deleteTarget,   setDeleteTarget]   = useState(null);
//   const [editTarget,     setEditTarget]     = useState(null);
//   const [showMinusModal, setShowMinusModal] = useState(false);

//   const [form, setForm] = useState({
//     date: new Date().toISOString().split("T")[0],
//     amount: "", type: "", notes: "", bookedBy: "",
//     useCustomDate: false,
//     customSubType: "",
//   });

//   useEffect(() => { fetchAll(); }, [sortOrder]); // eslint-disable-line react-hooks/exhaustive-deps

//   const fetchAll = async () => {
//     setLoading(true);
//     try {
//       const q    = query(collection(db, "Collection"), orderBy("date", sortOrder));
//       const snap = await getDocs(q);
//       // Load ALL entries (active + soft-deleted) — we split them in render
//       setCollections(snap.docs.map(d => ({ id: d.id, ...d.data() })));
//     } catch (err) { toast.error("Failed to load."); }
//     setLoading(false);
//   };

//   // ── Add ──
//   const handleSubmit = async () => {
//     if (!form.amount.trim() || !form.type.trim()) {
//       toast.error("Amount and type are required."); return;
//     }
//     if (form.type === "Custom" && !form.customSubType.trim()) {
//       toast.error("Please enter a name for the custom type."); return;
//     }
//     try {
//       const now = Timestamp.now();
//       const payload = {
//         date:          form.useCustomDate ? Timestamp.fromDate(new Date(form.date)) : now,
//         createdAt:     now,
//         amount:        form.amount,
//         type:          form.type,
//         customSubType: form.type === "Custom" ? form.customSubType.trim() : "",
//         notes:         form.notes,
//         bookedBy:      form.bookedBy,
//         history:       [],
//         deleted:       false,
//       };
//       const ref = await addDoc(collection(db, "Collection"), payload);
//       setCollections(prev => [{ id: ref.id, ...payload }, ...prev]);
//       toast.success("Entry added.");
//       setForm({
//         date: new Date().toISOString().split("T")[0],
//         amount: "", type: "", notes: "", bookedBy: "",
//         useCustomDate: false, customSubType: "",
//       });
//       setShowForm(false);
//     } catch { toast.error("Failed to add."); }
//   };

//   // ── Delete → soft-delete in place, keep in Collection doc ──
//   const handleDeleteConfirm = async (note, recipient) => {
//     const entry = deleteTarget;
//     try {
//       const update = {
//         deleted:           true,
//         deletedAt:         Timestamp.now(),
//         deletionNote:      note,
//         deletionRecipient: recipient,
//         amountAtDeletion:  entry.amount,
//       };
//       await updateDoc(doc(db, "Collection", entry.id), update);
//       setCollections(prev =>
//         prev.map(c => c.id === entry.id ? { ...c, ...update } : c)
//       );
//       toast.success("Entry marked as deleted.");
//     } catch { toast.error("Delete failed."); }
//     setDeleteTarget(null);
//   };

//   // ── Undelete ──
//   const handleUndelete = async (entry) => {
//     try {
//       const update = {
//         deleted:           false,
//         deletedAt:         null,
//         deletionNote:      null,
//         deletionRecipient: null,
//         amountAtDeletion:  null,
//         restoredAt:        Timestamp.now(),
//       };
//       await updateDoc(doc(db, "Collection", entry.id), update);
//       setCollections(prev =>
//         prev.map(c => c.id === entry.id ? { ...c, ...update } : c)
//       );
//       toast.success("Entry restored to active.");
//     } catch { toast.error("Restore failed."); }
//   };

//   // ── Edit — never deletes, always stays in active ──
//   const handleEditConfirm = async ({ amount, type, notes, editNote, recipient }) => {
//     const entry = editTarget;
//     const prevHistory = entry.history || [];
//     const historyEntry = {
//       at:         Timestamp.now(),
//       prevAmount: entry.amount,
//       newAmount:  amount,
//       prevType:   entry.type,
//       newType:    type,
//       editNote,
//       recipient,
//     };
//     try {
//       await updateDoc(doc(db, "Collection", entry.id), {
//         amount,
//         type,
//         notes,
//         history:      [...prevHistory, historyEntry],
//         lastEditedAt: Timestamp.now(),
//       });
//       setCollections(prev => prev.map(c =>
//         c.id === entry.id
//           ? { ...c, amount, type, notes, history: [...prevHistory, historyEntry] }
//           : c
//       ));
//       toast.success("Entry updated.");
//     } catch { toast.error("Edit failed."); }
//     setEditTarget(null);
//   };

//   // ── Minus Entry ──────────────────────────────────────────────
//   const handleMinusConfirm = async ({ amount, effectiveType, removingBy, notes }) => {
//     const activeEntries = collections.filter(c => !c.deleted);
//     const typeEntries = activeEntries
//       .filter(c => getEffectiveType(c) === effectiveType && (parseFloat(c.amount) || 0) > 0)
//       .sort((a, b) => {
//         const dateA = a.date?.toDate ? a.date.toDate() : new Date(a.date);
//         const dateB = b.date?.toDate ? b.date.toDate() : new Date(b.date);
//         return dateA - dateB;
//       });

//     const totalAvailable = typeEntries.reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);

//     if (amount > totalAvailable) {
//       toast.error(
//         `Available in "${effectiveType}" is ₹${totalAvailable.toLocaleString("en-IN")}. Cannot deduct ₹${amount.toLocaleString("en-IN")}.`
//       );
//       return;
//     }

//     let remaining = amount;

//     try {
//       for (const entry of typeEntries) {
//         if (remaining <= 0) break;

//         const entryAmount = parseFloat(entry.amount) || 0;
//         const prevHistory = entry.history || [];

//         if (entryAmount <= remaining) {
//           // Fully consumed → stays active, amount set to "0", history logged
//           remaining = parseFloat((remaining - entryAmount).toFixed(2));
//           const historyEntry = {
//             at:         Timestamp.now(),
//             prevAmount: String(entry.amount),
//             newAmount:  "0",
//             prevType:   entry.type,
//             newType:    entry.type,
//             editNote:   notes || "Minus entry deduction",
//             recipient:  removingBy || "—",
//           };
//           const update = {
//             amount:       "0",
//             history:      [...prevHistory, historyEntry],
//             lastEditedAt: Timestamp.now(),
//           };
//           await updateDoc(doc(db, "Collection", entry.id), update);
//           setCollections(prev =>
//             prev.map(c => c.id === entry.id ? { ...c, ...update } : c)
//           );
//         } else {
//           // Partial deduction
//           const newAmount = (entryAmount - remaining).toFixed(2);
//           remaining = 0;
//           const historyEntry = {
//             at:         Timestamp.now(),
//             prevAmount: String(entry.amount),
//             newAmount,
//             prevType:   entry.type,
//             newType:    entry.type,
//             editNote:   notes || "Minus entry deduction",
//             recipient:  removingBy || "—",
//           };
//           await updateDoc(doc(db, "Collection", entry.id), {
//             amount:       newAmount,
//             history:      [...prevHistory, historyEntry],
//             lastEditedAt: Timestamp.now(),
//           });
//           setCollections(prev =>
//             prev.map(c => c.id === entry.id
//               ? { ...c, amount: newAmount, history: [...prevHistory, historyEntry] }
//               : c
//             )
//           );
//         }
//       }

//       toast.success(`₹${amount.toLocaleString("en-IN")} deducted from "${effectiveType}" successfully.`);
//       setShowMinusModal(false);
//     } catch (err) {
//       console.error("Minus entry error:", err);
//       toast.error("Deduction failed. Please try again.");
//     }
//   };

//   const fmt = ts => {
//     if (!ts) return "—";
//     const d = ts.toDate ? ts.toDate() : new Date(ts);
//     return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
//   };

//   // ── Split into active / deleted ──
//   const activeCollections  = collections.filter(c => !c.deleted);
//   const deletedCollections = collections.filter(c =>  c.deleted);

//   // Totals and unique types are computed from active only
//   const totalAmount = activeCollections
//     .filter(c => typeFilter === "all" || getEffectiveType(c) === typeFilter)
//     .reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);

//   const uniqueTypes = [...new Set(activeCollections.map(getEffectiveType).filter(Boolean))];

//   // Active filtered list
//   const filteredActive = activeCollections.filter(c => {
//     if (typeFilter !== "all" && getEffectiveType(c) !== typeFilter) return false;
//     if (search) {
//       const s = search.toLowerCase();
//       if (
//         !getEffectiveType(c).toLowerCase().includes(s) &&
//         !(c.amount || "").toString().includes(s) &&
//         !(c.notes || "").toLowerCase().includes(s) &&
//         !(c.bookedBy || "").toLowerCase().includes(s)
//       ) return false;
//     }
//     return true;
//   });

//   // Deleted filtered list
//   const filteredDeleted = deletedCollections.filter(c => {
//     if (search) {
//       const s = search.toLowerCase();
//       if (
//         !getEffectiveType(c).toLowerCase().includes(s) &&
//         !(c.amount || "").toString().includes(s) &&
//         !(c.notes || "").toLowerCase().includes(s) &&
//         !(c.bookedBy || "").toLowerCase().includes(s) &&
//         !(c.deletionRecipient || "").toLowerCase().includes(s)
//       ) return false;
//     }
//     return true;
//   });

//   // ── Card renderer (shared for both tabs) ──────────────────
//   const renderCard = (col, isDeletedView) => {
//     const isOpen     = expanded === col.id;
//     const hasHistory = col.history && col.history.length > 0;
//     const isDeleted  = !!col.deleted;

//     return (
//       <div
//         key={col.id}
//         className={[
//           "dp-card",
//           isOpen    ? "dp-card-open"    : "",
//           isDeleted ? "cl-card-deleted" : "",
//         ].join(" ").trim()}
//       >
//         <div className="dp-card-header" onClick={() => setExpanded(isOpen ? null : col.id)}>
//           <div className="dp-card-left">
//             <span className={`cl-amount-pill${isDeleted ? " cl-amount-pill-deleted" : ""}`}>
//               ₹{parseFloat(col.amountAtDeletion || col.amount || 0).toLocaleString("en-IN")}
//             </span>
//             <span className="dp-card-name">{getEffectiveType(col) || "Unknown"}</span>

//             {/* Badges */}
//             {isDeleted && (
//               <span className="cl-deleted-badge">🗑 Deleted</span>
//             )}
//             {!isDeleted && hasHistory && (
//               <span className="cl-edited-badge">✏️ edited</span>
//             )}
//             {isDeleted && hasHistory && (
//               <span className="cl-edited-badge">📋 has history</span>
//             )}

//             <span className="dp-card-sub">
//               {fmt(col.date)}
//               {col.bookedBy ? ` · ${col.bookedBy}` : ""}
//               {col.notes    ? ` · ${col.notes}`    : ""}
//               {isDeleted && col.deletedAt ? ` · Deleted ${fmt(col.deletedAt)}` : ""}
//             </span>
//           </div>

//           <div className="cl-card-actions-row">
//             {/* Only show edit/delete on active entries */}
//             {!isDeleted && (
//               <>
//                 <button
//                   className="cl-edit-btn"
//                   onClick={e => { e.stopPropagation(); setEditTarget(col); }}
//                   title="Edit entry"
//                 >✏️</button>
//                 <button
//                   className="cl-del-btn"
//                   onClick={e => { e.stopPropagation(); setDeleteTarget(col); }}
//                   title="Delete entry"
//                 >🗑</button>
//               </>
//             )}
//             {/* Undelete button for deleted entries */}
//             {isDeleted && (
//               <button
//                 className="cl-undelete-btn"
//                 onClick={e => { e.stopPropagation(); handleUndelete(col); }}
//                 title="Restore entry"
//               >↩ Restore</button>
//             )}
//             <span className="dp-chevron">{isOpen ? "▲" : "▼"}</span>
//           </div>
//         </div>

//         {isOpen && (
//           <div className="dp-card-body">
//             <div className="dp-info-grid">
//               <div className="dp-info-item">
//                 <span className="dp-info-key">
//                   {isDeleted ? "Amount at Deletion" : "Amount"}
//                 </span>
//                 <span className="dp-info-val" style={{ fontWeight: 700, fontSize: "1.05rem", color: isDeleted ? "#c0392b" : "#27ae60" }}>
//                   ₹{parseFloat(isDeleted ? (col.amountAtDeletion || col.amount || 0) : (col.amount || 0)).toLocaleString("en-IN")}
//                 </span>
//               </div>
//               <div className="dp-info-item">
//                 <span className="dp-info-key">Type</span>
//                 <span className="dp-info-val">{getEffectiveType(col) || "—"}</span>
//               </div>
//               <div className="dp-info-item">
//                 <span className="dp-info-key">Date</span>
//                 <span className="dp-info-val">{fmt(col.date)}</span>
//               </div>
//               <div className="dp-info-item">
//                 <span className="dp-info-key">Collected By</span>
//                 <span className="dp-info-val">{col.bookedBy || "—"}</span>
//               </div>
//               {isDeleted && (
//                 <>
//                   <div className="dp-info-item">
//                     <span className="dp-info-key">Deleted On</span>
//                     <span className="dp-info-val">{fmt(col.deletedAt)}</span>
//                   </div>
//                   <div className="dp-info-item">
//                     <span className="dp-info-key">Recipient</span>
//                     <span className="dp-info-val">{col.deletionRecipient || "—"}</span>
//                   </div>
//                   {col.deletionNote && (
//                     <div className="dp-info-item dp-info-full">
//                       <span className="dp-info-key">Deletion Reason</span>
//                       <span className="dp-info-val">{col.deletionNote}</span>
//                     </div>
//                   )}
//                 </>
//               )}
//               {col.notes && (
//                 <div className="dp-info-item dp-info-full">
//                   <span className="dp-info-key">Notes</span>
//                   <span className="dp-info-val">{col.notes}</span>
//                 </div>
//               )}
//             </div>

//             {/* Audit Timeline — only shown when there is actual history */}
//             {hasHistory && (
//               <AuditTimeline entry={col} />
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="dp-root">
//       <ToastContainer />

//       {deleteTarget && (
//         <DeleteModal
//           entry={deleteTarget}
//           onConfirm={handleDeleteConfirm}
//           onCancel={() => setDeleteTarget(null)}
//         />
//       )}

//       {editTarget && (
//         <EditModal
//           entry={editTarget}
//           onConfirm={handleEditConfirm}
//           onCancel={() => setEditTarget(null)}
//         />
//       )}

//       {showMinusModal && (
//         <MinusEntryModal
//           collections={collections}
//           onConfirm={handleMinusConfirm}
//           onCancel={() => setShowMinusModal(false)}
//         />
//       )}

//       {/* Header */}
//       <div className="dp-header">
//         <div className="dp-header-left">
//           <span className="dp-header-icon">💰</span>
//           <div>
//             <h2 className="dp-title">Collection</h2>
//             <p className="dp-subtitle">Track donations, zakat, and all financial collections</p>
//           </div>
//         </div>
//         <div className="dp-header-btns">
//           <button className="dp-refresh-btn" onClick={fetchAll}>↻ Refresh</button>
//           <button
//             className="cl-deleted-btn"
//             onClick={() => setShowDeleted(v => !v)}
//           >
//             {showDeleted
//               ? "📋 Show Active"
//               : `🗑 Deleted (${deletedCollections.length})`
//             }
//           </button>
//           <button className="cl-minus-btn" onClick={() => setShowMinusModal(true)}>
//             − Minus Entry
//           </button>
//           <button className="dp-add-btn" onClick={() => setShowForm(v => !v)}>
//             {showForm ? "✕ Close" : "+ Add Entry"}
//           </button>
//         </div>
//       </div>

//       {/* Add Entry Form */}
//       {showForm && (
//         <div className="cl-add-form">
//           <h3 className="cl-form-title">New Collection Entry</h3>
//           <div className="cl-form-grid">
//             <div className="cl-form-field">
//               <label>Amount (₹) *</label>
//               <input
//                 type="number"
//                 placeholder="Enter amount"
//                 value={form.amount}
//                 onChange={e => setForm(p => ({ ...p, amount: e.target.value }))}
//               />
//             </div>
//             <div className="cl-form-field">
//               <label>Type *</label>
//               <select
//                 value={form.type}
//                 onChange={e => setForm(p => ({ ...p, type: e.target.value, customSubType: "" }))}
//               >
//                 <option value="">Select type</option>
//                 {COLLECTION_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
//               </select>
//             </div>

//             {form.type === "Custom" && (
//               <div className="cl-form-field">
//                 <label>Custom Type Name *</label>
//                 <input
//                   placeholder="e.g. Goat Sacrifice, Eid Collection…"
//                   value={form.customSubType}
//                   onChange={e => setForm(p => ({ ...p, customSubType: e.target.value }))}
//                 />
//               </div>
//             )}

//             <div className="cl-form-field">
//               <label>Collected By</label>
//               <select
//                 value={form.bookedBy}
//                 onChange={e => setForm(p => ({ ...p, bookedBy: e.target.value }))}
//               >
//                 <option value="">Select volunteer</option>
//                 {VOLUNTEERS.map(v => <option key={v} value={v}>{v}</option>)}
//               </select>
//             </div>
//             <div className="cl-form-field">
//               <label>Notes</label>
//               <input
//                 placeholder="Optional notes"
//                 value={form.notes}
//                 onChange={e => setForm(p => ({ ...p, notes: e.target.value }))}
//               />
//             </div>
//             <div className="cl-form-field">
//               <label style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
//                 <input
//                   type="checkbox"
//                   checked={form.useCustomDate}
//                   onChange={e => setForm(p => ({ ...p, useCustomDate: e.target.checked }))}
//                 />
//                 Custom Date
//               </label>
//               {form.useCustomDate && (
//                 <input
//                   type="date"
//                   value={form.date}
//                   onChange={e => setForm(p => ({ ...p, date: e.target.value }))}
//                 />
//               )}
//               {!form.useCustomDate && <span className="cl-date-note">Using today's date</span>}
//             </div>
//           </div>
//           <div className="cl-form-actions">
//             <button className="dp-cancel-btn" onClick={() => setShowForm(false)}>Cancel</button>
//             <button className="dp-save-btn" onClick={handleSubmit}>Add Entry</button>
//           </div>
//         </div>
//       )}

//       {/* ── DELETED TAB ── */}
//       {showDeleted ? (
//         <div className="cl-deleted-section">
//           <div className="cl-deleted-section-header">
//             <h3 className="cl-deleted-title">🗑 Deleted Records ({filteredDeleted.length})</h3>
//             <p className="cl-deleted-subtitle">
//               Full audit trail shown for each entry. Restore any entry to active.
//             </p>
//           </div>

//           {/* Search within deleted */}
//           <div className="dp-filters">
//             <input
//               className="dp-search"
//               placeholder="Search deleted records…"
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//             />
//             <span className="dp-count">{filteredDeleted.length} records</span>
//           </div>

//           {filteredDeleted.length === 0 ? (
//             <div className="dp-empty"><span>📭</span><p>No deleted records.</p></div>
//           ) : (
//             <div className="dp-list">
//               {filteredDeleted.map(d => renderCard(d, true))}
//             </div>
//           )}
//         </div>
//       ) : (
//         <>
//           {/* Summary Row */}
//           <div className="cl-summary-row">
//             <div className="cl-total-card">
//               <span className="cl-total-label">
//                 {typeFilter === "all" ? "Total Collected" : typeFilter}
//               </span>
//               <span className="cl-total-amount">
//                 ₹{totalAmount.toLocaleString("en-IN")}
//               </span>
//               <span className="cl-total-sub">{filteredActive.length} entr{filteredActive.length !== 1 ? "ies" : "y"}</span>
//             </div>
//             <div className="cl-type-pills">
//               <button
//                 className={"cl-type-pill" + (typeFilter === "all" ? " cl-type-active" : "")}
//                 onClick={() => setTypeFilter("all")}
//               >All</button>
//               {uniqueTypes.map(t => (
//                 <button
//                   key={t}
//                   className={"cl-type-pill" + (typeFilter === t ? " cl-type-active" : "")}
//                   onClick={() => setTypeFilter(t === typeFilter ? "all" : t)}
//                 >{t}</button>
//               ))}
//             </div>
//           </div>

//           {/* Filters */}
//           <div className="dp-filters">
//             <input
//               className="dp-search"
//               placeholder="Search by type, amount, notes or volunteer…"
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//             />
//             <select className="dp-select" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
//               <option value="desc">Newest First</option>
//               <option value="asc">Oldest First</option>
//             </select>
//             <span className="dp-count">{filteredActive.length} records</span>
//           </div>

//           {/* Active list */}
//           {loading ? (
//             <div className="dp-loading"><div className="dp-spinner" /><p>Loading…</p></div>
//           ) : filteredActive.length === 0 ? (
//             <div className="dp-empty"><span>📭</span><p>No collection entries found.</p></div>
//           ) : (
//             <div className="dp-list">
//               {filteredActive.map(col => renderCard(col, false))}
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Collection;



import React, { useEffect, useState } from "react";
import {
  collection, addDoc, getDocs, doc,
  updateDoc, Timestamp, orderBy, query,
} from "firebase/firestore";
import { db } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import "../css/datapanel.css";
import "../css/collection.css";

// ── Cloudinary Config ─────────────────────────────────────────────────────────
const CLOUDINARY_CLOUD_NAME = "decikvy0b";
const CLOUDINARY_UPLOAD_PRESET = "ij5ifyyw";

const ACCEPTED_MINUS_TYPES =
  "image/png,image/jpg,image/jpeg,image/webp,image/tiff,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const COLLECTION_TYPES = [
  "Zakat", "Fitrah", "Mustahab Sadqah", "Sehme Imam",
  "Sehme Saadat", "Fidya", "Kaffara", "Akiqah",
  "Donation", "Custom",
];

const VOLUNTEERS = [
  "Ahmad Raza Najmuddin", "Zain", "Abbas Mirza", "Ali Mohammad",
  "Hussain", "Mahdi", "Arsalan", "Ali Mehdi", "Ali Abbas",
];

const MINUS_PURPOSE_OPTIONS = ["Medical", "School", "Ration", "Custom"];

// ── Helper: returns customSubType for Custom entries, otherwise type ──────────
const getEffectiveType = (c) =>
  c.type === "Custom" && c.customSubType ? c.customSubType : (c.type || "");

// ── Cloudinary upload helper for minus entry docs ─────────────────────────────
const uploadMinusDocs = async (files, effectiveType) => {
  const timestamp = Date.now();
  const uploaded = [];

  for (const file of files) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
    fd.append("public_id", `minusEntries/${effectiveType}/${timestamp}/${file.name}`);

    const ext = file.name.split(".").pop().toLowerCase();
    const isRaw = ["pdf", "doc", "docx", "tiff", "xlsx", "xls"].includes(ext);
    const resourceType = isRaw ? "raw" : "image";

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`,
      { method: "POST", body: fd }
    );
    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData?.error?.message || "Upload failed");
    }
    const data = await res.json();
    uploaded.push({
      url: data.secure_url,
      name: file.name,
      resourceType,
      publicId: data.public_id,
    });
  }
  return uploaded;
};

// ── Build a unified timeline from history + deletion event ────────────────────
const buildTimeline = (entry) => {
  const events = [];

  // 1. Creation event
  events.push({
    at:        entry.createdAt || entry.date || null,
    eventType: "created",
    label:     "Entry Created",
    newAmount: entry.history && entry.history.length > 0
      ? entry.history[0].prevAmount
      : entry.amount,
    recipient: entry.bookedBy || "—",
    note:      entry.notes || "",
    documents: [],
  });

  // 2. History events
  (entry.history || []).forEach((h) => {
    const isMinus = h.editNote === "Minus entry deduction" || h.isMinus === true;
    events.push({
      at:         h.at,
      eventType:  isMinus ? "minus" : "edit",
      label:      isMinus ? "Manual Minus" : "Manual Edit",
      prevAmount: h.prevAmount,
      newAmount:  h.newAmount,
      deducted:   h.deducted,          // only present for minus
      recipient:  h.recipient || "—",
      note:       h.editNote || "",
      purpose:    h.purpose || "",
      purposeCustom: h.purposeCustom || "",
      documents:  h.documents || [],
    });
  });

  // 3. Deletion event
  if (entry.deleted) {
    events.push({
      at:         entry.deletedAt || null,
      eventType:  "deleted",
      label:      "Marked Deleted",
      prevAmount: entry.amountAtDeletion || entry.amount,
      newAmount:  "0",
      recipient:  entry.deletionRecipient || "—",
      note:       entry.deletionNote || "",
      documents:  [],
    });
  }

  return events;
};

// ── Badge logic ───────────────────────────────────────────────────────────────
const getBadges = (entry) => {
  const history = entry.history || [];
  const hasMinus = history.some(h => h.editNote === "Minus entry deduction" || h.isMinus === true);
  const hasEdit  = history.some(h => h.editNote !== "Minus entry deduction" && !h.isMinus);
  const badges = [];
  if (hasMinus) badges.push("minus");
  if (hasEdit)  badges.push("edit");
  return badges;
};

// ── Delete Modal ──────────────────────────────────────────────────────────────
function DeleteModal({ entry, onConfirm, onCancel }) {
  const [note, setNote] = useState("");
  const [recipient, setRecipient] = useState("");
  return (
    <div className="cl-modal-bg" onClick={onCancel}>
      <div className="cl-modal" onClick={e => e.stopPropagation()}>
        <h3 className="cl-modal-title">🗑 Delete Entry</h3>
        <p className="cl-modal-desc">
          Deleting <strong>₹{entry.amount} — {getEffectiveType(entry)}</strong>.<br />
          The entry will be marked as deleted and moved to the deleted view,
          with full history preserved.
        </p>
        <div className="cl-modal-field">
          <label>Recipient / Who Got Helped *</label>
          <input
            value={recipient}
            onChange={e => setRecipient(e.target.value)}
            placeholder="e.g. Mohammed Ali, Raza family"
          />
        </div>
        <div className="cl-modal-field">
          <label>Note (reason for deletion / details)</label>
          <textarea
            rows={3}
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="e.g. Amount given to beneficiary for medical treatment…"
          />
        </div>
        <div className="cl-modal-actions">
          <button className="dp-cancel-btn" onClick={onCancel}>Cancel</button>
          <button
            className="cl-delete-confirm-btn"
            onClick={() => {
              if (!recipient.trim()) { toast.error("Recipient is required."); return; }
              onConfirm(note, recipient);
            }}
          >
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Edit Modal ────────────────────────────────────────────────────────────────
function EditModal({ entry, onConfirm, onCancel }) {
  const [amount,    setAmount]    = useState(entry.amount);
  const [type,      setType]      = useState(entry.type);
  const [notes,     setNotes]     = useState(entry.notes || "");
  const [editNote,  setEditNote]  = useState("");
  const [recipient, setRecipient] = useState("");

  return (
    <div className="cl-modal-bg" onClick={onCancel}>
      <div className="cl-modal" onClick={e => e.stopPropagation()}>
        <h3 className="cl-modal-title">✏️ Edit Entry</h3>
        <p className="cl-modal-desc">
          Original: <strong>₹{entry.amount} — {getEffectiveType(entry)}</strong>
        </p>
        <div className="cl-modal-grid">
          <div className="cl-modal-field">
            <label>New Amount (₹) *</label>
            <input
              type="number"
              value={amount}
              onChange={e => setAmount(e.target.value)}
            />
          </div>
          <div className="cl-modal-field">
            <label>Type</label>
            <select value={type} onChange={e => setType(e.target.value)}>
              {COLLECTION_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
        </div>
        <div className="cl-modal-field">
          <label>Entry Notes</label>
          <input value={notes} onChange={e => setNotes(e.target.value)} placeholder="Notes…" />
        </div>
        <div className="cl-modal-field">
          <label>Who received the difference / reason for edit *</label>
          <input
            value={recipient}
            onChange={e => setRecipient(e.target.value)}
            placeholder="e.g. Hussain family received ₹500"
          />
        </div>
        <div className="cl-modal-field">
          <label>Edit Note</label>
          <textarea
            rows={2}
            value={editNote}
            onChange={e => setEditNote(e.target.value)}
            placeholder="Describe what changed and why…"
          />
        </div>
        <div className="cl-modal-actions">
          <button className="dp-cancel-btn" onClick={onCancel}>Cancel</button>
          <button
            className="dp-save-btn"
            onClick={() => {
              if (!recipient.trim()) { toast.error("Recipient is required."); return; }
              onConfirm({ amount, type, notes, editNote, recipient });
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Minus Entry Modal ─────────────────────────────────────────────────────────
function MinusEntryModal({ collections, onConfirm, onCancel }) {
  const [amount,       setAmount]       = useState("");
  const [type,         setType]         = useState("");
  const [customSub,    setCustomSub]    = useState("");
  const [removingBy,   setRemovingBy]   = useState("");
  const [notes,        setNotes]        = useState("");

  // Purpose fields
  const [purpose,       setPurpose]       = useState("");
  const [purposeCustom, setPurposeCustom] = useState("");

  // Document upload
  const [docFiles,    setDocFiles]    = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const availableNonCustomTypes = [...new Set(
    collections
      .filter(c => c.type !== "Custom" && !c.deleted && (parseFloat(c.amount) || 0) > 0)
      .map(c => c.type).filter(Boolean)
  )];

  const customSubTypes = [...new Set(
    collections
      .filter(c => c.type === "Custom" && c.customSubType && !c.deleted && (parseFloat(c.amount) || 0) > 0)
      .map(c => c.customSubType)
  )];

  const hasCustomEntries = customSubTypes.length > 0;
  const effectiveLabel = type === "Custom" ? customSub : type;

  const availableForType = (() => {
    if (!type) return 0;
    if (type === "Custom") {
      if (!customSub) return 0;
      return collections
        .filter(c => c.type === "Custom" && c.customSubType === customSub && !c.deleted)
        .reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
    }
    return collections
      .filter(c => c.type === type && !c.deleted)
      .reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
  })();

  const showBanner = type && (type !== "Custom" || customSub);
  const parsedAmount = parseFloat(amount);
  const isOver = showBanner && amount && parsedAmount > availableForType;

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setDocFiles(prev => [...prev, ...selected]);
  };

  const removeFile = (idx) => {
    setDocFiles(prev => prev.filter((_, i) => i !== idx));
  };

  const handleConfirm = async () => {
    if (!amount || isNaN(parsedAmount) || parsedAmount <= 0) {
      toast.error("Enter a valid amount greater than 0."); return;
    }
    if (!type) { toast.error("Please select a type."); return; }
    if (type === "Custom" && !customSub) {
      toast.error("Please select a custom sub-type."); return;
    }
    if (!purpose) { toast.error("Please select a purpose."); return; }
    if (purpose === "Custom" && !purposeCustom.trim()) {
      toast.error("Please enter a custom purpose name."); return;
    }
    if (availableForType === 0) {
      toast.error(`No entries found for "${effectiveLabel}".`); return;
    }
    if (parsedAmount > availableForType) {
      toast.error(
        `Available in "${effectiveLabel}" is ₹${availableForType.toLocaleString("en-IN")}. Please enter ₹${availableForType.toLocaleString("en-IN")} or less.`
      );
      return;
    }

    // Upload docs if any
    let uploadedDocs = [];
    if (docFiles.length > 0) {
      setIsUploading(true);
      try {
        const et = type === "Custom" ? customSub : type;
        uploadedDocs = await uploadMinusDocs(docFiles, et);
      } catch (err) {
        toast.error(`File upload failed: ${err.message}`);
        setIsUploading(false);
        return;
      }
      setIsUploading(false);
    }

    const effectiveType = type === "Custom" ? customSub : type;
    onConfirm({
      amount: parsedAmount,
      effectiveType,
      removingBy,
      notes,
      purpose,
      purposeCustom: purpose === "Custom" ? purposeCustom.trim() : "",
      documents: uploadedDocs,
    });
  };

  return (
    <div className="cl-modal-bg" onClick={onCancel}>
      <div className="cl-modal cl-modal-wide" onClick={e => e.stopPropagation()}>
        <h3 className="cl-modal-title">➖ Minus Entry</h3>
        <p className="cl-modal-desc">
          Deduct an amount from the <strong>oldest entries first</strong> of the selected type.
          Fully consumed entries stay active with ₹0 and full history preserved.
        </p>

        {/* Row 1: Type + Amount */}
        <div className="cl-modal-grid">
          <div className="cl-modal-field">
            <label>Type *</label>
            <select
              value={type}
              onChange={e => { setType(e.target.value); setCustomSub(""); }}
            >
              <option value="">Select type</option>
              {availableNonCustomTypes.map(t => <option key={t} value={t}>{t}</option>)}
              {hasCustomEntries && <option value="Custom">Custom</option>}
            </select>
          </div>
          <div className="cl-modal-field">
            <label>Amount (₹) *</label>
            <input
              type="number"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              placeholder="Enter amount"
              min="1"
            />
          </div>
        </div>

        {type === "Custom" && (
          <div className="cl-modal-field">
            <label>Custom Sub-Type *</label>
            <select value={customSub} onChange={e => setCustomSub(e.target.value)}>
              <option value="">Select custom type</option>
              {customSubTypes.map(st => <option key={st} value={st}>{st}</option>)}
            </select>
          </div>
        )}

        {showBanner && (
          <div className={`cl-minus-available${isOver ? " cl-minus-over" : ""}`}>
            {isOver
              ? `⚠️ Exceeds available! Only ₹${availableForType.toLocaleString("en-IN")} available in "${effectiveLabel}"`
              : `✅ Available in "${effectiveLabel}": ₹${availableForType.toLocaleString("en-IN")}`
            }
          </div>
        )}

        {/* Purpose */}
        <div className="cl-modal-grid">
          <div className="cl-modal-field">
            <label>Purpose *</label>
            <select value={purpose} onChange={e => { setPurpose(e.target.value); setPurposeCustom(""); }}>
              <option value="">Select purpose</option>
              {MINUS_PURPOSE_OPTIONS.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div className="cl-modal-field">
            <label>Removing By</label>
            <select value={removingBy} onChange={e => setRemovingBy(e.target.value)}>
              <option value="">Select volunteer</option>
              {VOLUNTEERS.map(v => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>
        </div>

        {purpose === "Custom" && (
          <div className="cl-modal-field">
            <label>Custom Purpose Name *</label>
            <input
              value={purposeCustom}
              onChange={e => setPurposeCustom(e.target.value)}
              placeholder="e.g. Wedding help, Funeral expenses…"
            />
          </div>
        )}

        {/* Notes */}
        <div className="cl-modal-field">
          <label>Notes</label>
          <textarea
            rows={2}
            value={notes}
            onChange={e => setNotes(e.target.value)}
            placeholder="Reason for deduction, recipient details…"
          />
        </div>

        {/* Document Upload */}
        <div className="cl-modal-field">
          <label>Documents (optional)</label>
          <div className="cl-doc-upload-area">
            <label htmlFor="minus-doc-upload" className="cl-doc-upload-label">
              <span className="cl-doc-upload-icon">📎</span>
              <span>Click to attach files</span>
              <span className="cl-doc-upload-hint">JPG, PNG, GIF, WEBP, TIFF, PDF, DOC, DOCX, XLS, XLSX</span>
            </label>
            <input
              id="minus-doc-upload"
              type="file"
              multiple
              accept={ACCEPTED_MINUS_TYPES}
              className="cl-doc-file-input"
              onChange={handleFileChange}
            />
          </div>
          {docFiles.length > 0 && (
            <div className="cl-doc-file-list">
              {docFiles.map((f, i) => (
                <div key={i} className="cl-doc-file-item">
                  <span className="cl-doc-file-name">📄 {f.name}</span>
                  <button
                    className="cl-doc-file-remove"
                    onClick={() => removeFile(i)}
                    type="button"
                  >✕</button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="cl-modal-actions">
          <button className="dp-cancel-btn" onClick={onCancel} disabled={isUploading}>Cancel</button>
          <button className="cl-minus-confirm-btn" onClick={handleConfirm} disabled={isUploading}>
            {isUploading ? (
              <><span className="cl-upload-spinner" /> Uploading...</>
            ) : (
              "Deduct Amount"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Audit Timeline Component ──────────────────────────────────────────────────
function AuditTimeline({ entry }) {
  const events = buildTimeline(entry);
  const fmt = ts => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  const iconMap = {
    created: "🟢",
    edit:    "✏️",
    minus:   "➖",
    deleted: "🗑",
  };

  return (
    <div className="cl-timeline">
      <h4 className="cl-timeline-title">📋 Full Audit Trail</h4>
      <div className="cl-timeline-list">
        {events.map((ev, i) => {
          const prev = parseFloat(ev.prevAmount || 0);
          const next = parseFloat(ev.newAmount  || 0);
          // For minus: compute how much was deducted from this specific entry
          const deducted = ev.deducted != null
            ? parseFloat(ev.deducted)
            : (ev.eventType === "minus" ? parseFloat((prev - next).toFixed(2)) : null);

          return (
            <div key={i} className={`cl-timeline-item cl-tl-${ev.eventType}`}>
              <div className="cl-tl-dot">{iconMap[ev.eventType]}</div>
              <div className="cl-tl-body">
                <div className="cl-tl-row">
                  <span className="cl-tl-label">{ev.label}</span>
                  <span className="cl-tl-date">{fmt(ev.at)}</span>
                </div>

                {/* Amount display */}
                <div className="cl-tl-amounts">
                  {ev.eventType === "created" ? (
                    <span className="cl-tl-new">
                      ₹{parseFloat(ev.newAmount || 0).toLocaleString("en-IN")}
                    </span>
                  ) : ev.eventType === "minus" ? (
                    /* Format: 800 - 520 → 280 */
                    <>
                      <span className="cl-tl-prev">₹{prev.toLocaleString("en-IN")}</span>
                      <span className="cl-tl-minus-op"> − </span>
                      <span className="cl-tl-deducted">₹{deducted != null ? deducted.toLocaleString("en-IN") : "?"}</span>
                      <span className="cl-tl-arrow"> → </span>
                      <span className={`cl-tl-new${next === 0 ? " cl-tl-zero" : ""}`}>
                        ₹{next.toLocaleString("en-IN")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="cl-tl-prev">₹{prev.toLocaleString("en-IN")}</span>
                      <span className="cl-tl-arrow">→</span>
                      <span className={`cl-tl-new${ev.eventType === "deleted" ? " cl-tl-zero" : ""}`}>
                        ₹{next.toLocaleString("en-IN")}
                      </span>
                    </>
                  )}
                </div>

                {/* Purpose for minus events */}
                {ev.eventType === "minus" && ev.purpose && (
                  <div className="cl-tl-purpose">
                    🎯 {ev.purpose === "Custom" && ev.purposeCustom ? ev.purposeCustom : ev.purpose}
                  </div>
                )}

                {ev.recipient && ev.recipient !== "—" && (
                  <div className="cl-tl-meta">👤 {ev.recipient}</div>
                )}
                {ev.note && ev.note !== "Minus entry deduction" && (
                  <div className="cl-tl-note">{ev.note}</div>
                )}

                {/* Attached documents */}
                {ev.documents && ev.documents.length > 0 && (
                  <div className="cl-tl-docs">
                    <span className="cl-tl-docs-label">📎 Attachments:</span>
                    <div className="cl-tl-docs-list">
                      {ev.documents.map((d, di) => (
                        <a
                          key={di}
                          href={d.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cl-tl-doc-link"
                        >
                          {d.name}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
const Collection = () => {
  const [collections,    setCollections]    = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [showForm,       setShowForm]       = useState(false);
  const [showDeleted,    setShowDeleted]    = useState(false);
  const [search,         setSearch]         = useState("");
  const [typeFilter,     setTypeFilter]     = useState("all");
  const [sortOrder,      setSortOrder]      = useState("desc");
  const [expanded,       setExpanded]       = useState(null);
  const [deleteTarget,   setDeleteTarget]   = useState(null);
  const [editTarget,     setEditTarget]     = useState(null);
  const [showMinusModal, setShowMinusModal] = useState(false);

  const [form, setForm] = useState({
    date: new Date().toISOString().split("T")[0],
    amount: "", type: "", notes: "", bookedBy: "",
    useCustomDate: false,
    customSubType: "",
  });

  useEffect(() => { fetchAll(); }, [sortOrder]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchAll = async () => {
    setLoading(true);
    try {
      const q    = query(collection(db, "Collection"), orderBy("date", sortOrder));
      const snap = await getDocs(q);
      setCollections(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) { toast.error("Failed to load."); }
    setLoading(false);
  };

  // ── Add ──
  const handleSubmit = async () => {
    if (!form.amount.trim() || !form.type.trim()) {
      toast.error("Amount and type are required."); return;
    }
    if (form.type === "Custom" && !form.customSubType.trim()) {
      toast.error("Please enter a name for the custom type."); return;
    }
    try {
      const now = Timestamp.now();
      const payload = {
        date:          form.useCustomDate ? Timestamp.fromDate(new Date(form.date)) : now,
        createdAt:     now,
        amount:        form.amount,
        type:          form.type,
        customSubType: form.type === "Custom" ? form.customSubType.trim() : "",
        notes:         form.notes,
        bookedBy:      form.bookedBy,
        history:       [],
        deleted:       false,
      };
      const ref = await addDoc(collection(db, "Collection"), payload);
      setCollections(prev => [{ id: ref.id, ...payload }, ...prev]);
      toast.success("Entry added.");
      setForm({
        date: new Date().toISOString().split("T")[0],
        amount: "", type: "", notes: "", bookedBy: "",
        useCustomDate: false, customSubType: "",
      });
      setShowForm(false);
    } catch { toast.error("Failed to add."); }
  };

  // ── Delete → soft-delete ──
  const handleDeleteConfirm = async (note, recipient) => {
    const entry = deleteTarget;
    try {
      const update = {
        deleted:           true,
        deletedAt:         Timestamp.now(),
        deletionNote:      note,
        deletionRecipient: recipient,
        amountAtDeletion:  entry.amount,
      };
      await updateDoc(doc(db, "Collection", entry.id), update);
      setCollections(prev =>
        prev.map(c => c.id === entry.id ? { ...c, ...update } : c)
      );
      toast.success("Entry marked as deleted.");
    } catch { toast.error("Delete failed."); }
    setDeleteTarget(null);
  };

  // ── Undelete ──
  const handleUndelete = async (entry) => {
    try {
      const update = {
        deleted:           false,
        deletedAt:         null,
        deletionNote:      null,
        deletionRecipient: null,
        amountAtDeletion:  null,
        restoredAt:        Timestamp.now(),
      };
      await updateDoc(doc(db, "Collection", entry.id), update);
      setCollections(prev =>
        prev.map(c => c.id === entry.id ? { ...c, ...update } : c)
      );
      toast.success("Entry restored to active.");
    } catch { toast.error("Restore failed."); }
  };

  // ── Edit ──
  const handleEditConfirm = async ({ amount, type, notes, editNote, recipient }) => {
    const entry = editTarget;
    const prevHistory = entry.history || [];
    const historyEntry = {
      at:         Timestamp.now(),
      prevAmount: entry.amount,
      newAmount:  amount,
      prevType:   entry.type,
      newType:    type,
      editNote,
      recipient,
      isMinus:    false,
    };
    try {
      await updateDoc(doc(db, "Collection", entry.id), {
        amount,
        type,
        notes,
        history:      [...prevHistory, historyEntry],
        lastEditedAt: Timestamp.now(),
      });
      setCollections(prev => prev.map(c =>
        c.id === entry.id
          ? { ...c, amount, type, notes, history: [...prevHistory, historyEntry] }
          : c
      ));
      toast.success("Entry updated.");
    } catch { toast.error("Edit failed."); }
    setEditTarget(null);
  };

  // ── Minus Entry ───────────────────────────────────────────────────────────
  const handleMinusConfirm = async ({ amount, effectiveType, removingBy, notes, purpose, purposeCustom, documents }) => {
    const activeEntries = collections.filter(c => !c.deleted);
    const typeEntries = activeEntries
      .filter(c => getEffectiveType(c) === effectiveType && (parseFloat(c.amount) || 0) > 0)
      .sort((a, b) => {
        const dateA = a.date?.toDate ? a.date.toDate() : new Date(a.date);
        const dateB = b.date?.toDate ? b.date.toDate() : new Date(b.date);
        return dateA - dateB;
      });

    const totalAvailable = typeEntries.reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);

    if (amount > totalAvailable) {
      toast.error(
        `Available in "${effectiveType}" is ₹${totalAvailable.toLocaleString("en-IN")}. Cannot deduct ₹${amount.toLocaleString("en-IN")}.`
      );
      return;
    }

    let remaining = amount;

    try {
      for (const entry of typeEntries) {
        if (remaining <= 0) break;

        const entryAmount  = parseFloat(entry.amount) || 0;
        const prevHistory  = entry.history || [];

        if (entryAmount <= remaining) {
          // Fully consumed
          const deducted = entryAmount;
          remaining = parseFloat((remaining - entryAmount).toFixed(2));

          const historyEntry = {
            at:           Timestamp.now(),
            prevAmount:   String(entry.amount),
            newAmount:    "0",
            deducted:     String(deducted),
            prevType:     entry.type,
            newType:      entry.type,
            editNote:     notes || "Minus entry deduction",
            recipient:    removingBy || "—",
            isMinus:      true,
            purpose,
            purposeCustom,
            documents,
          };
          const update = {
            amount:       "0",
            history:      [...prevHistory, historyEntry],
            lastEditedAt: Timestamp.now(),
          };
          await updateDoc(doc(db, "Collection", entry.id), update);
          setCollections(prev =>
            prev.map(c => c.id === entry.id ? { ...c, ...update } : c)
          );
        } else {
          // Partial deduction
          const deducted  = remaining;
          const newAmount = (entryAmount - remaining).toFixed(2);
          remaining = 0;

          const historyEntry = {
            at:           Timestamp.now(),
            prevAmount:   String(entry.amount),
            newAmount,
            deducted:     String(deducted),
            prevType:     entry.type,
            newType:      entry.type,
            editNote:     notes || "Minus entry deduction",
            recipient:    removingBy || "—",
            isMinus:      true,
            purpose,
            purposeCustom,
            documents,
          };
          await updateDoc(doc(db, "Collection", entry.id), {
            amount:       newAmount,
            history:      [...prevHistory, historyEntry],
            lastEditedAt: Timestamp.now(),
          });
          setCollections(prev =>
            prev.map(c => c.id === entry.id
              ? { ...c, amount: newAmount, history: [...prevHistory, historyEntry] }
              : c
            )
          );
        }
      }

      toast.success(`₹${amount.toLocaleString("en-IN")} deducted from "${effectiveType}" successfully.`);
      setShowMinusModal(false);
    } catch (err) {
      console.error("Minus entry error:", err);
      toast.error("Deduction failed. Please try again.");
    }
  };

  const fmt = ts => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  // ── Split active / deleted ────────────────────────────────────────────────
  const activeCollections  = collections.filter(c => !c.deleted);
  const deletedCollections = collections.filter(c =>  c.deleted);

  const totalAmount = activeCollections
    .filter(c => typeFilter === "all" || getEffectiveType(c) === typeFilter)
    .reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);

  const uniqueTypes = [...new Set(activeCollections.map(getEffectiveType).filter(Boolean))];

  const filteredActive = activeCollections.filter(c => {
    if (typeFilter !== "all" && getEffectiveType(c) !== typeFilter) return false;
    if (search) {
      const s = search.toLowerCase();
      if (
        !getEffectiveType(c).toLowerCase().includes(s) &&
        !(c.amount || "").toString().includes(s) &&
        !(c.notes || "").toLowerCase().includes(s) &&
        !(c.bookedBy || "").toLowerCase().includes(s)
      ) return false;
    }
    return true;
  });

  const filteredDeleted = deletedCollections.filter(c => {
    if (search) {
      const s = search.toLowerCase();
      if (
        !getEffectiveType(c).toLowerCase().includes(s) &&
        !(c.amount || "").toString().includes(s) &&
        !(c.notes || "").toLowerCase().includes(s) &&
        !(c.bookedBy || "").toLowerCase().includes(s) &&
        !(c.deletionRecipient || "").toLowerCase().includes(s)
      ) return false;
    }
    return true;
  });

  // ── Card renderer ─────────────────────────────────────────────────────────
  const renderCard = (col, isDeletedView) => {
    const isOpen     = expanded === col.id;
    const hasHistory = col.history && col.history.length > 0;
    const isDeleted  = !!col.deleted;
    const badges     = getBadges(col);

    return (
      <div
        key={col.id}
        className={[
          "dp-card",
          isOpen    ? "dp-card-open"    : "",
          isDeleted ? "cl-card-deleted" : "",
        ].join(" ").trim()}
      >
        <div className="dp-card-header" onClick={() => setExpanded(isOpen ? null : col.id)}>
          <div className="dp-card-left">
            <span className={`cl-amount-pill${isDeleted ? " cl-amount-pill-deleted" : ""}`}>
              ₹{parseFloat(col.amountAtDeletion || col.amount || 0).toLocaleString("en-IN")}
            </span>
            <span className="dp-card-name">{getEffectiveType(col) || "Unknown"}</span>

            {/* Badges */}
            {isDeleted && (
              <span className="cl-deleted-badge">🗑 Deleted</span>
            )}
            {!isDeleted && badges.includes("minus") && (
              <span className="cl-minussed-badge">➖ minussed</span>
            )}
            {!isDeleted && badges.includes("edit") && (
              <span className="cl-edited-badge">✏️ edited</span>
            )}
            {isDeleted && hasHistory && (
              <span className="cl-edited-badge">📋 has history</span>
            )}

            <span className="dp-card-sub">
              {fmt(col.date)}
              {col.bookedBy ? ` · ${col.bookedBy}` : ""}
              {col.notes    ? ` · ${col.notes}`    : ""}
              {isDeleted && col.deletedAt ? ` · Deleted ${fmt(col.deletedAt)}` : ""}
            </span>
          </div>

          <div className="cl-card-actions-row">
            {!isDeleted && (
              <>
                <button
                  className="cl-edit-btn"
                  onClick={e => { e.stopPropagation(); setEditTarget(col); }}
                  title="Edit entry"
                >✏️</button>
                <button
                  className="cl-del-btn"
                  onClick={e => { e.stopPropagation(); setDeleteTarget(col); }}
                  title="Delete entry"
                >🗑</button>
              </>
            )}
            {isDeleted && (
              <button
                className="cl-undelete-btn"
                onClick={e => { e.stopPropagation(); handleUndelete(col); }}
                title="Restore entry"
              >↩ Restore</button>
            )}
            <span className="dp-chevron">{isOpen ? "▲" : "▼"}</span>
          </div>
        </div>

        {isOpen && (
          <div className="dp-card-body">
            <div className="dp-info-grid">
              <div className="dp-info-item">
                <span className="dp-info-key">
                  {isDeleted ? "Amount at Deletion" : "Amount"}
                </span>
                <span className="dp-info-val" style={{ fontWeight: 700, fontSize: "1.05rem", color: isDeleted ? "#c0392b" : "#27ae60" }}>
                  ₹{parseFloat(isDeleted ? (col.amountAtDeletion || col.amount || 0) : (col.amount || 0)).toLocaleString("en-IN")}
                </span>
              </div>
              <div className="dp-info-item">
                <span className="dp-info-key">Type</span>
                <span className="dp-info-val">{getEffectiveType(col) || "—"}</span>
              </div>
              <div className="dp-info-item">
                <span className="dp-info-key">Date</span>
                <span className="dp-info-val">{fmt(col.date)}</span>
              </div>
              <div className="dp-info-item">
                <span className="dp-info-key">Collected By</span>
                <span className="dp-info-val">{col.bookedBy || "—"}</span>
              </div>
              {isDeleted && (
                <>
                  <div className="dp-info-item">
                    <span className="dp-info-key">Deleted On</span>
                    <span className="dp-info-val">{fmt(col.deletedAt)}</span>
                  </div>
                  <div className="dp-info-item">
                    <span className="dp-info-key">Recipient</span>
                    <span className="dp-info-val">{col.deletionRecipient || "—"}</span>
                  </div>
                  {col.deletionNote && (
                    <div className="dp-info-item dp-info-full">
                      <span className="dp-info-key">Deletion Reason</span>
                      <span className="dp-info-val">{col.deletionNote}</span>
                    </div>
                  )}
                </>
              )}
              {col.notes && (
                <div className="dp-info-item dp-info-full">
                  <span className="dp-info-key">Notes</span>
                  <span className="dp-info-val">{col.notes}</span>
                </div>
              )}
            </div>

            {hasHistory && <AuditTimeline entry={col} />}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="dp-root">
      <ToastContainer />

      {deleteTarget && (
        <DeleteModal
          entry={deleteTarget}
          onConfirm={handleDeleteConfirm}
          onCancel={() => setDeleteTarget(null)}
        />
      )}

      {editTarget && (
        <EditModal
          entry={editTarget}
          onConfirm={handleEditConfirm}
          onCancel={() => setEditTarget(null)}
        />
      )}

      {showMinusModal && (
        <MinusEntryModal
          collections={collections}
          onConfirm={handleMinusConfirm}
          onCancel={() => setShowMinusModal(false)}
        />
      )}

      {/* Header */}
      <div className="dp-header">
        <div className="dp-header-left">
          <span className="dp-header-icon">💰</span>
          <div>
            <h2 className="dp-title">Collection</h2>
            <p className="dp-subtitle">Track donations, zakat, and all financial collections</p>
          </div>
        </div>
        <div className="dp-header-btns">
          <button className="dp-refresh-btn" onClick={fetchAll}>↻ Refresh</button>
          <button
            className="cl-deleted-btn"
            onClick={() => setShowDeleted(v => !v)}
          >
            {showDeleted
              ? "📋 Show Active"
              : `🗑 Deleted (${deletedCollections.length})`
            }
          </button>
          <button className="cl-minus-btn" onClick={() => setShowMinusModal(true)}>
            − Minus Entry
          </button>
          <button className="dp-add-btn" onClick={() => setShowForm(v => !v)}>
            {showForm ? "✕ Close" : "+ Add Entry"}
          </button>
        </div>
      </div>

      {/* Add Entry Form */}
      {showForm && (
        <div className="cl-add-form">
          <h3 className="cl-form-title">New Collection Entry</h3>
          <div className="cl-form-grid">
            <div className="cl-form-field">
              <label>Amount (₹) *</label>
              <input
                type="number"
                placeholder="Enter amount"
                value={form.amount}
                onChange={e => setForm(p => ({ ...p, amount: e.target.value }))}
              />
            </div>
            <div className="cl-form-field">
              <label>Type *</label>
              <select
                value={form.type}
                onChange={e => setForm(p => ({ ...p, type: e.target.value, customSubType: "" }))}
              >
                <option value="">Select type</option>
                {COLLECTION_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            {form.type === "Custom" && (
              <div className="cl-form-field">
                <label>Custom Type Name *</label>
                <input
                  placeholder="e.g. Goat Sacrifice, Eid Collection…"
                  value={form.customSubType}
                  onChange={e => setForm(p => ({ ...p, customSubType: e.target.value }))}
                />
              </div>
            )}

            <div className="cl-form-field">
              <label>Collected By</label>
              <select
                value={form.bookedBy}
                onChange={e => setForm(p => ({ ...p, bookedBy: e.target.value }))}
              >
                <option value="">Select volunteer</option>
                {VOLUNTEERS.map(v => <option key={v} value={v}>{v}</option>)}
              </select>
            </div>
            <div className="cl-form-field">
              <label>Notes</label>
              <input
                placeholder="Optional notes"
                value={form.notes}
                onChange={e => setForm(p => ({ ...p, notes: e.target.value }))}
              />
            </div>
            <div className="cl-form-field">
              <label style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <input
                  type="checkbox"
                  checked={form.useCustomDate}
                  onChange={e => setForm(p => ({ ...p, useCustomDate: e.target.checked }))}
                />
                Custom Date
              </label>
              {form.useCustomDate && (
                <input
                  type="date"
                  value={form.date}
                  onChange={e => setForm(p => ({ ...p, date: e.target.value }))}
                />
              )}
              {!form.useCustomDate && <span className="cl-date-note">Using today's date</span>}
            </div>
          </div>
          <div className="cl-form-actions">
            <button className="dp-cancel-btn" onClick={() => setShowForm(false)}>Cancel</button>
            <button className="dp-save-btn" onClick={handleSubmit}>Add Entry</button>
          </div>
        </div>
      )}

      {/* ── DELETED TAB ── */}
      {showDeleted ? (
        <div className="cl-deleted-section">
          <div className="cl-deleted-section-header">
            <h3 className="cl-deleted-title">🗑 Deleted Records ({filteredDeleted.length})</h3>
            <p className="cl-deleted-subtitle">
              Full audit trail shown for each entry. Restore any entry to active.
            </p>
          </div>

          <div className="dp-filters">
            <input
              className="dp-search"
              placeholder="Search deleted records…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <span className="dp-count">{filteredDeleted.length} records</span>
          </div>

          {filteredDeleted.length === 0 ? (
            <div className="dp-empty"><span>📭</span><p>No deleted records.</p></div>
          ) : (
            <div className="dp-list">
              {filteredDeleted.map(d => renderCard(d, true))}
            </div>
          )}
        </div>
      ) : (
        <>
          {/* Summary Row */}
          <div className="cl-summary-row">
            <div className="cl-total-card">
              <span className="cl-total-label">
                {typeFilter === "all" ? "Total Collected" : typeFilter}
              </span>
              <span className="cl-total-amount">
                ₹{totalAmount.toLocaleString("en-IN")}
              </span>
              <span className="cl-total-sub">{filteredActive.length} entr{filteredActive.length !== 1 ? "ies" : "y"}</span>
            </div>
            <div className="cl-type-pills">
              <button
                className={"cl-type-pill" + (typeFilter === "all" ? " cl-type-active" : "")}
                onClick={() => setTypeFilter("all")}
              >All</button>
              {uniqueTypes.map(t => (
                <button
                  key={t}
                  className={"cl-type-pill" + (typeFilter === t ? " cl-type-active" : "")}
                  onClick={() => setTypeFilter(t === typeFilter ? "all" : t)}
                >{t}</button>
              ))}
            </div>
          </div>

          {/* Filters */}
          <div className="dp-filters">
            <input
              className="dp-search"
              placeholder="Search by type, amount, notes or volunteer…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <select className="dp-select" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
              <option value="desc">Newest First</option>
              <option value="asc">Oldest First</option>
            </select>
            <span className="dp-count">{filteredActive.length} records</span>
          </div>

          {/* Active list */}
          {loading ? (
            <div className="dp-loading"><div className="dp-spinner" /><p>Loading…</p></div>
          ) : filteredActive.length === 0 ? (
            <div className="dp-empty"><span>📭</span><p>No collection entries found.</p></div>
          ) : (
            <div className="dp-list">
              {filteredActive.map(col => renderCard(col, false))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Collection;